<template>
    <div class="rfq" >
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm">
                    <el-form-item label="公司名称">
                        <el-input v-model="searchForm.companyName" placeholder="公司名称" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="() => {this.currentPage=1;onSearch();}" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    :data="tableData"
                    v-loading="loading"
                    style="width: 100%">
                    <el-table-column prop="companyName" label="公司名称" min-width="200"></el-table-column>
                    <el-table-column prop="agreement" label="销售协议" width="200"></el-table-column>
                    <el-table-column prop="userName" label="下单账号" width="200"></el-table-column>
                    <el-table-column prop="supplierId" label="供应商ID" width="120"></el-table-column>
                    <el-table-column prop="appKey" label="MRO账号" width="300"></el-table-column>
                    <el-table-column prop="appSecret" label="MRO密码" width="300"></el-table-column>
                    <!-- <el-table-column prop="mallAppKey" label="商城账号" width="150"></el-table-column>
                    <el-table-column prop="mallAppSecret" label="商城密码" width="150"></el-table-column> -->

                    <el-table-column label="操作" width="160" align="right" fixed="right">
                        <template slot="header">
                            <el-button type="primary" size="mini" @click="handleCreate()">添加客户接口配置</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        stripe
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        v-if="total>0"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="客户接口配置" :visible.sync="editDialogVisible" width="500px" :close-on-click-modal="false">
            <el-form ref="editForm" :model="editForm" :rules="rules" label-width="90px">
                <el-form-item label="客户公司" prop="companyId" size="mini">
                    <el-select v-model="editForm.companyId"  placeholder="请选择客户公司"
                        :disabled="editForm.id"
                        @change="handleChangeCompany()"
                        style="width: 100%" clearable>
                        <el-option
                            v-for="item in companys"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="销售协议" prop="agreementId" size="mini">
                    <el-select v-model="editForm.agreementId"  placeholder="请选择销售协议" style="width: 100%" clearable>
                        <el-option
                            v-for="item in agreements"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="下单账号" prop="userId" size="mini">
                    <el-select v-model="editForm.userId"  placeholder="请选择下单账号" style="width: 100%" clearable>
                        <el-option
                            v-for="item in users"
                            :key="item.key"
                            :label="item.value"
                            :value="item.key">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商ID" prop="supplierId" size="mini">
                    <el-input v-model="editForm.supplierId" placeholder="请输入供应商ID" clearable></el-input>
                </el-form-item>
                <el-form-item label="MRO账号" prop="appKey" size="mini">
                    <el-input v-model="editForm.appKey" placeholder="请输入MRO账号" clearable></el-input>
                </el-form-item>
                <el-form-item label="MRO密钥" prop="appSecret" size="mini">
                    <el-input v-model="editForm.appSecret" placeholder="请输入MRO密钥" clearable></el-input>
                </el-form-item>
                <!-- <el-form-item label="商城账号" prop="mallAppKey" size="mini">
                    <el-input v-model="editForm.mallAppKey" placeholder="请输入商城账号" clearable></el-input>
                </el-form-item>
                <el-form-item label="商城密码" prop="mallAppSecret" size="mini">
                    <el-input v-model="editForm.mallAppSecret" placeholder="请输入商城密码" clearable></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false" size="small">取 消</el-button>
                <el-button type="primary" @click="handleEdit" size="small">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>

export default {

    data() {
        return {
            editDialogVisible:false,
            companys:[],
            users: [],
            agreements: [],
            searchForm: {
                companyName: ""
            },
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            editForm: {},

            rules: {
                companyId: [
                    { required: true, message: '请选择客户公司', trigger: 'blur' }
                ],
                agreementId: [
                    { required: true, message: '请选择销售协议', trigger: 'blur' }
                ],
                userId: [
                    { required: true, message: '请选择下单账号', trigger: 'blur' }
                ],
                supplierId: [
                    { required: true, message: '请输入供应商ID', trigger: 'blur' }
                ],
                appKey: [
                    { required: true, message: '请输入MRO账号', trigger: 'blur' }
                ],
                appSecret: [
                    { required: true, message: '请输入MRO密码', trigger: 'blur' }
                ],
                // mallAppKey: [
                //     { required: true, message: '请输入商城账号', trigger: 'blur' }
                // ],
                // mallAppSecret: [
                //     { required: true, message: '请输入商城密码', trigger: 'blur' }
                // ],
            },
        }
    },
    methods: {
        onSearch() {
            this.loading = true;
            this.selectData = [];
            let _this = this
            let cond = {...this.searchForm};

            this.$axios.post("/admin/config/customer/api/search",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            }).finally(() => {
                _this.loading = false;
            });
        },
        loadCompanys(){
            const that = this;
            this.$axios.get("/admin/config/customer/api/loadCompany"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.companys = resp.data;
                }
            });
        },
        handleCreate() {
            this.editDialogVisible = true;
            this.editForm = {};
        },
        handleDelete(row){
            const that = this;
            this.$axios.get(`/admin/config/customer/api/delete/${row.id}`
            ).then(function () {
                that.onSearch();
            });
        },
        handleChangeCompany() {
            if(this.editForm.companyId) {
                const that = this;
                this.$axios.get(`/admin/config/customer/api/loadAgreements/${this.editForm.companyId}`
                ).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.agreements = resp.data;
                    }
                });
                this.$axios.get(`/admin/config/customer/api/loadUsers/${this.editForm.companyId}`
                ).then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.users = resp.data;
                    }
                });
            } else {
                this.users = []
            }
        },
        handleEdit() {
            const that = this;
            this.$axios.post('/admin/config/customer/api/save', this.editForm
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    that.onSearch();
                    that.editDialogVisible = false;
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                }
            });
        }
    },
    created() {
        this.onSearch();
        this.loadCompanys();
    },
}
</script>
